export default __webpack_public_path__ + "static/media/modul-image-1.f9765e53.png";